/*
SaiKrishna 10/06/2022 3075154998 Removed unnecessary console.log statements
Suresh Peddavoora 10/26/2022 3075154998  Added Class Name for Table Enhancements
Ashraf 10/30/2022 3075154998 fixed table pagination issue
saikrishna 11/03/2022 3075154998 changed the paginationOptions
Raghu 11/30/2022 3075154998 Table footer styling fixes
*/
import React, {createRef, useState} from 'react';
// import MaterialTable from "material-table";
import {tableIcons} from '../../../../../components/TableIcons';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {TablePagination} from '@material-ui/core';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../../../constants/ReusableConstants';

export default function ConditionTable({tableData}) {
  const [rows, setRows] = useState(defaultRows);

  const columns = [
    // {
    //   title: "Code",
    //   field: "code",
    //   cellStyle: { maxWidth: 500 },
    //   minWidth: "300px",
    // },
    {
      title: 'Seq No',
      field: 'sequenceNumber',
      // headerStyle: {
      //   textAlign: "center",
      // },
      // cellStyle: {
      //   maxWidth: 100,
      //   textAlign: "center",
      // },
      // render: (rowData) => {
      //   const rowSeqNo = rowData?.tableData?.id
      //     ? rowData?.tableData?.id + 1
      //     : rowData?.tableData?.id === 0
      //       ? 1
      //       : "";
      //   // conditionData[rowData?.tableData?.id].seqNo = rowSeqNo;
      //   return rowSeqNo;
      // },
    },
    {
      title: 'Report ID',
      field: 'detailId',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        maxWidth: 200,
      },
    },
    {
      title: 'Record Format',
      field: 'recordFormat',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        maxWidth: 200,
      },
    },
    {
      title: 'Srt',
      field: 'srt',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        maxWidth: 200,
      },
    },
    {
      title: 'Length',
      field: 'length',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        maxWidth: 200,
      },
    },
    {
      title: 'Text Value',
      field: 'textValue',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        maxWidth: 200,
      },
    },
  ];
  const tableRef = createRef();
  const [isDelete, setIsDelete] = useState(false);

  const handleClose = () => {
    setIsDelete(false);
  };

  const handleSubmit = () => {};
  return (
    <div>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title="Delete Condition"
        value={`Are you sure you want to delete this condition?`}
        handleSubmit={handleSubmit}
      />
      <div className="custom-table global-field-table">
        <GuiTable
          title=""
          columns={columns}
          icons={tableIcons}
          tableRef={tableRef}
          // data={[]}
          data={tableData ? tableData : []}
          options={{
            search: false,
            toolbar: false,
            pageSize: rows,
            showSelectAllCheckbox: false,
            emptyRowsWhenPaging: false,
            headerStyle: {
              fontWeight: 'bold',
            },
          }}
          components={{
            Pagination: (props) => (
              <div className="global-field-table-footer">
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              </div>
            )}}
          //   actions={[
          //     {
          //       icon: "edit",
          //       tooltip: "Edit",
          //       onClick: (event, rowData) => {
          //         // handleConditionEdit(rowData);
          //         // setConditionCode(rowData.id);
          //       },
          //     },
          //     {
          //       icon: "delete",
          //       tooltip: "Delete",
          //       onClick: (event, rowData) => {
          //         // handleDelete(rowData);
          //         // setIsDelete(true);
          //       },
          //     },
          //   ]}
        />
      </div>
    </div>
  );
}
